export default "__VITE_ASSET__Cm$eUE8d__"